import { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import NavigationMenu from "./navigationMenu";
import constants from "../constants/constants";
import { useUserParams } from "../hooks/useUserParams";


const DesktopNav = ({ pathname }) => {
  const { getCurrentLogo } = useUserParams();
  const logoUrl = getCurrentLogo();
  const [activeMenu, setActiveMenu] = useState(null);

  const handleMenuHover = (menu) => {
    setActiveMenu(menu);
  };

  return (
    <div
      style={{ gridTemplateColumns: "1fr auto 1fr" }}
      className="w-full py-4 px-8 grid min-h-28 items-center bg-gradient-to-r from-[#23272f]/80 via-[#18181b]/90 to-[#23272f]/80 backdrop-blur-lg rounded-b-3xl shadow-2xl border-b border-[#23272f]/60"
    >
      <img
        src={logoUrl}
        alt="Logo"
        width={96}
        height={96}
        className="w-24 drop-shadow-[0_0_16px_#ffffff] animate-pulse"
        style={{ filter: "drop-shadow(0 0 16px #ffffff)" }}
      />

      <nav className="flex gap-x-10 justify-center font-semibold child:relative mt-2 text-white">
        {constants.NAV_ITEMS.map((item) =>
          item.items.length > 0 ? (
            <div
              key={item.label}
              className={`cursor-pointer pb-2 transition-all duration-300 group ${
                activeMenu === item.label
                  ? "text-white drop-shadow-[0_0_8px_#ffffff]"
                  : "hover:text-white hover:drop-shadow-[0_0_8px_#ffffff]"
              }`}
              onMouseEnter={() => handleMenuHover(item.label)}
              onMouseLeave={() => handleMenuHover(null)}
            >
              {item.label}
              <FontAwesomeIcon
                icon={faAngleDown}
                className={`ml-2 w-3 h-3 inline-block transition-transform duration-300 ${
                  activeMenu === item.label
                    ? "fa-flip-vertical text-white"
                    : "group-hover:text-white"
                }`}
              />
              {activeMenu === item.label && (
                <div className="absolute left-1/2 -translate-x-1/2 mt-3 z-40 animate-fadeIn">
                  <div className="rounded-2xl shadow-2xl border border-[#23272f]/60 bg-gradient-to-br from-[#23272f]/95 via-[#18181b]/95 to-[#23272f]/95 backdrop-blur-lg p-2 min-w-[200px]">
                    <NavigationMenu items={[...item.items]} />
                  </div>
                </div>
              )}
            </div>
          ) : (
            <Link
              key={item.label}
              to={item.href}
              className={`transition-all duration-300 ${
                window.location.pathname === item.href
                  ? "text-white drop-shadow-[0_0_8px_#ffffff]"
                  : "hover:text-white hover:drop-shadow-[0_0_8px_#ffffff]"
              }`}
            >
              {item.label}
            </Link>
          )
        )}
      </nav>
    </div>
  );
};

export default DesktopNav;
